<template>
  <div class="container">
    <a-card :loading="loading">
      <div class="header-section">
        <a-row type="flex" justify="space-between" align="middle" class="margin-bottom-20" :gutter="[16, 16]">
          <a-col :flex="auto">
            <h2 class="page-title">事件类型列表</h2>
          </a-col>
          <a-col :flex="none">
            <a-button type="primary" icon="plus" @click="handleAdd">新增类型</a-button>
          </a-col>
        </a-row>
      </div>

      <div class="search-form margin-bottom-20">
        <a-row :gutter="[16, 16]">
          <a-col :xxl="6" :xl="8" :lg="10" :md="24" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <a-input v-model="searchForm.name" placeholder="请输入类型名称" allowClear />
            </a-form-item>
          </a-col>
          <a-col :xxl="6" :xl="8" :lg="10" :md="24" :sm="24" :xs="24">
            <a-form-item class="search-form-item">
              <a-space class="search-buttons-wrapper">
                <a-button type="primary" @click="search" icon="search">查询</a-button>
                <a-button @click="resetSearch" icon="reload">重置</a-button>
              </a-space>
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <a-table 
        :dataSource="tableData" 
        :columns="columns" 
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{ x: 'max-content' }"
        rowKey="id">
        <template slot="tag_color" slot-scope="text">
          <a-tag :color="getColorByIndex(parseInt(text))">{{ getColorName(parseInt(text)) }}</a-tag>
        </template>
        <template slot="action" slot-scope="record">
          <a-button type="link" @click="handleEdit(record)">编辑</a-button>
          <a-popconfirm
            title="确定要删除这个类型吗？"
            @confirm="handleDelete(record)"
          >
            <a-button type="link" style="color: red;">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>

    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      :confirm-loading="modalConfirmLoading"
      @ok="submitForm"
      @cancel="handleModalCancel"
      :width="600"
    >
      <a-form :form="form" layout="vertical">
        <a-form-item label="类型名称">
          <a-input 
            v-decorator="['name', { 
              rules: [{ required: true, message: '请输入类型名称' }] 
            }]" 
            placeholder="请输入类型名称" />
        </a-form-item>
        
        <a-form-item label="标签颜色">
          <a-select
            v-decorator="['tag_color', { initialValue: '0' }]"
            placeholder="请选择标签颜色">
            <a-select-option value="0">
              <a-tag color="blue">蓝色</a-tag>
            </a-select-option>
            <a-select-option value="1">
              <a-tag color="green">绿色</a-tag>
            </a-select-option>
            <a-select-option value="2">
              <a-tag color="red">红色</a-tag>
            </a-select-option>
            <a-select-option value="3">
              <a-tag color="orange">橙色</a-tag>
            </a-select-option>
            <a-select-option value="4">
              <a-tag color="purple">紫色</a-tag>
            </a-select-option>
          </a-select>
        </a-form-item>
        
        <a-form-item label="级别">
          <a-input-number 
            v-decorator="['level', { initialValue: 1 }]"
            :min="1"
            :max="10"
            style="width: 100%"
            placeholder="请输入级别 (1-10)" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'EventTypes',
  data() {
    return {
      loading: false,
      modalVisible: false,
      modalConfirmLoading: false,
      modalType: 'add', // 'add' 或 'edit'
      currentRecord: null,
      tableData: [],
      searchForm: {
        name: ''
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        page_no: 1,
        page_size: 10
      },
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 80
        },
        {
          title: '类型名称',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: '标签颜色',
          dataIndex: 'tag_color',
          key: 'tag_color',
          scopedSlots: { customRender: 'tag_color' }
        },
        {
          title: '级别',
          dataIndex: 'level',
          key: 'level'
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          key: 'created_at'
        },
        {
          title: '更新时间',
          dataIndex: 'updated_at',
          key: 'updated_at'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 150
        }
      ],
      // 颜色映射
      colorMap: [
        { name: '蓝色', color: 'blue' },
        { name: '绿色', color: 'green' },
        { name: '红色', color: 'red' },
        { name: '橙色', color: 'orange' },
        { name: '紫色', color: 'purple' }
      ]
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    modalTitle() {
      return this.modalType === 'add' ? '新增事件类型' : '编辑事件类型';
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 根据颜色索引获取颜色名称
    getColorName(index) {
      return this.colorMap[index] ? this.colorMap[index].name : '未知';
    },

    // 根据颜色索引获取颜色值
    getColorByIndex(index) {
      return this.colorMap[index] ? this.colorMap[index].color : 'default';
    },

    // 获取列表数据
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          page_no: this.pagination.current,
          page_size: this.pagination.pageSize,
          ...this.searchForm
        };
        
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key];
          }
        });
        
        const res = await this.$api.get_event_types(params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          // 修改分页字段适配
          this.pagination.current = parseInt(res.data.page.page_no);
          this.pagination.pageSize = parseInt(res.data.page.page_size);
          this.pagination.total = res.data.page.total;
        } else {
          this.$message.error(res.message || '获取事件类型列表失败');
        }
      } catch (error) {
        console.error('获取事件类型列表失败:', error);
        this.$message.error('获取事件类型列表失败');
      } finally {
        this.loading = false;
      }
    },

    // 查询
    search() {
      this.pagination.current = 1;
      this.fetchData();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        name: ''
      };
      this.pagination.current = 1;
      this.fetchData();
    },

    // 处理表格分页、排序等变化
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchData();
    },

    // 新增
    handleAdd() {
      this.modalType = 'add';
      this.currentRecord = null;
      this.modalVisible = true;
      this.$nextTick(() => {
        this.form.resetFields();
      });
    },

    // 编辑
    handleEdit(record) {
      this.modalType = 'edit';
      this.currentRecord = { ...record };
      this.modalVisible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          tag_color: String(record.tag_color),
          level: record.level
        });
      });
    },

    // 删除
    async handleDelete(record) {
      try {
        const res = await this.$api.delete_event_type(record.id);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        } else {
          this.$message.error(res.message || '删除失败');
        }
      } catch (error) {
        console.error('删除失败:', error);
        this.$message.error('删除失败');
      }
    },

    // 提交表单
    submitForm() {
      this.form.validateFields(async (err, values) => {
        if (err) return;
        
        this.modalConfirmLoading = true;
        try {
          let res;
          if (this.modalType === 'edit') {
            // 编辑
            res = await this.$api.update_event_type(this.currentRecord.id, {
              ...values,
              tag_color: parseInt(values.tag_color)
            });
          } else {
            // 新增
            res = await this.$api.create_event_type({
              ...values,
              tag_color: parseInt(values.tag_color)
            });
          }
          
          if (res.code === 200) {
            this.$message.success(this.modalType === 'edit' ? '更新成功' : '新增成功');
            this.modalVisible = false;
            this.fetchData();
          } else {
            this.$message.error(res.message || (this.modalType === 'edit' ? '更新失败' : '新增失败'));
          }
        } catch (error) {
          console.error('操作失败:', error);
          this.$message.error(this.modalType === 'edit' ? '更新失败' : '新增失败');
        } finally {
          this.modalConfirmLoading = false;
        }
      });
    },

    // 关闭对话框
    handleModalCancel() {
      this.modalVisible = false;
      this.form.resetFields();
    }
  }
};
</script>

<style scoped>
.margin-bottom-20 {
  margin-bottom: 20px;
}

.page-title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}

/* 搜索表单样式 */
.search-form {
  background: #fafafa;
  padding: 16px;
  border-radius: 4px;
}

.search-form-item {
  margin-bottom: 0;
}

.search-form-item :deep(.ant-form-item-label) {
  padding-bottom: 4px;
}

.search-buttons-wrapper {
  display: flex;
  width: 100%;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .page-title {
    font-size: 18px;
    margin-bottom: 0;
  }
  
  .header-section .ant-row {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .header-section .ant-col {
    width: 100%;
  }
  
  .header-section .ant-btn {
    width: 100%;
    margin-top: 12px;
  }
  
  .search-form {
    padding: 12px;
  }
  
  .search-form-item :deep(.ant-form-item-label) {
    text-align: left;
  }
  
  .search-buttons-wrapper {
    width: 100%;
    gap: 8px;
  }
  
  .search-buttons-wrapper .ant-btn {
    flex: 1;
  }
}

/* Pad端和中等屏幕优化 (比手机宽，比PC窄) */
@media (min-width: 769px) and (max-width: 1199px) {
  .page-title {
    font-size: 19px;
  }
  
  .search-buttons-wrapper {
    width: 100%;
    gap: 8px;
  }
  
  .search-buttons-wrapper .ant-btn {
    flex: 1;
  }
}

/* PC端优化 (1200px以上) */
@media (min-width: 1200px) {
  .search-buttons-wrapper {
    gap: 8px;
    justify-content: flex-start;
  }
}

/* 表格响应式 */
:deep(.ant-table) {
  overflow-x: auto;
}

:deep(.ant-table-wrapper) {
  overflow-x: auto;
}

:deep(.ant-table-body) {
  overflow-x: auto;
}

/* 小屏幕下表格操作按钮 */
@media (max-width: 576px) {
  :deep(.ant-table-wrapper) {
    font-size: 14px;
  }
  
  :deep(.ant-btn-link) {
    padding: 0 4px;
  }
}

/* Modal响应式 */
@media (max-width: 768px) {
  :deep(.ant-modal) {
    max-width: calc(100vw - 32px);
    margin: 16px auto;
  }
}
</style>